module.exports = __webpack_public_path__ + "static/media/desk.959d2622.svg";